export const AGENT_DESCRIPTION_MAX = 400;
export const AGENT_SYSTEM_MAX = 4000;

export function normalizeAgentNewlines(value) {
  return String(value ?? '').replace(/\r\n?/g, '\n');
}

export function clampAgentText(value, max) {
  return normalizeAgentNewlines(value).slice(0, max);
}
